import { useCallback } from 'react';

import { useModalConfirmationContext } from '../modalConfirmationContext';
import { type EmailVerificationFlow, useSendVerificationEmail } from '../useSendVerificationEmail';

type Props = { showContinueAsGuest: boolean; flow: EmailVerificationFlow; path: string };

export function useInformVerificationEmail(): (props: Props) => Promise<void> {
	const sendVerificationEmail = useSendVerificationEmail();

	const [, { displayModal }] = useModalConfirmationContext();

	return useCallback(
		async ({ showContinueAsGuest, flow, path }) => {
			// not great UX to be sending an email every time the page is loaded/refreshed
			void sendVerificationEmail(path, flow);
			await displayModal({ type: 'emailVerification', path, showContinueAsGuest, flow });
		},
		[sendVerificationEmail, displayModal],
	);
}
